<template>
  <div class="col-12 py-1 px-0">
    <load v-if="loading" mode="table" />
    <div
      class="card card-body table table-sm bg-white border-4 border-bottom border-primary"
      v-for="historico in historicos"
      :key="historico.id"
    >
      <div v-if="historico.new_values">
        <div
          class="row py-2"
          style="border-bottom: 2px solid #007bff !important"
        >
          <!-- <div class="col-12 py-1">
      <button class="btn btn-warning btn-sm" @click="restaurar">
           <i class="mdi mdi-undo mr-3"></i>Restaurar
         </button>
     </div> -->
          <div class="col-12 mb-3">
            <b>ABA:</b>
            {{
              historico.auditable_type
                .replace("Modules\\Acolhimento\\Entities\\Acolhimento", "")
                .replace(
                  "DadoJuridicos",
                  "Documentação/Identificação Processual"
                )
                .replace("Profissionalizacao", "Profissionalização")
                .replace("PrimeiraObservacao", "Primeira Observação")
                .replace("Crianca", "Detalhes do Acolhimento")
                .replace("Educacao", "Educação")
                .replace("CaractSaude", "Saúde e Desenvolvimento")
                .replace("DinamicaFamiliar", "Tipo de vínculo")
                .replace(
                  "MetaResponsavel",
                  "Objetivos e Metas - Pais e responsáveis"
                )
                .replace(
                  "MetaDetalhes do Acolhimento",
                  "Objetivos e Metas - Criança e Adolescente"
                )
            }}
          </div>
          <div class="col-6">
            <b>DATA DE REGISTRO:</b>
            {{ historico.created_at | moment("DD/MM/YYYY H:mm") }}<br />
            <b>EVENTO:</b> {{ historico.event }}
          </div>
          <div class="col-6">
            <b>RESPONSÁVEL PELA EDIÇÃO:</b> {{ historico.tecnico.nome }} -
            <small>{{ historico.tecnico.unidade.nome }} </small>
          </div>
        </div>
        <b v-if="historico.new_values.arte_meta">ARTE META:</b>
        <div class="row" v-html="historico.new_values.arte_meta"></div>
        <b v-if="historico.new_values.arte_situacao_atual"
          >ARTE SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.arte_situacao_atual"
        ></div>
        <b v-if="historico.new_values.aspecto_meta">ASPECTO META:</b>
        <div class="row" v-html="historico.new_values.aspecto_meta"></div>
        <b v-if="historico.new_values.aspecto_situacao_atual"
          >ASPECTO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.aspecto_situacao_atual"
        ></div>

        <b v-if="historico.new_values.condicao_meta">CONDIÇÃO META:</b>
        <div class="row" v-html="historico.new_values.condicao_meta"></div>
        <b v-if="historico.new_values.aspecto_situacao_atual"
          >CONDIÇÃO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.condicao_situacao_atual"
        ></div>

        <b v-if="historico.new_values.desligamento_meta">DESLIGAMENTO META:</b>
        <div class="row" v-html="historico.new_values.desligamento_meta"></div>
        <b v-if="historico.new_values.desligamento_situacao_atual"
          >DESLIGAMENTO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.desligamento_situacao_atual"
        ></div>

        <b v-if="historico.new_values.documental_meta">DOCUMENTAL META:</b>
        <div class="row" v-html="historico.new_values.documental_meta"></div>
        <b v-if="historico.new_values.documental_situacao_atual"
          >DOCUMENTAL SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.documental_situacao_atual"
        ></div>

        <b v-if="historico.new_values.educacao_meta">EDUCAÇÃO META:</b>
        <div class="row" v-html="historico.new_values.educacao_meta"></div>
        <b v-if="historico.new_values.educacao_situacao_atual"
          >EDUCAÇÃO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.educacao_situacao_atual"
        ></div>

        <b v-if="historico.new_values.processual_meta">PROCESSUAL META:</b>
        <div class="row" v-html="historico.new_values.processual_meta"></div>
        <b v-if="historico.new_values.processual_situacao_atual"
          >PROCESSUAL SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.processual_situacao_atual"
        ></div>

        <b v-if="historico.new_values.profissionalizacao_meta"
          >PROFISSIONALIZAÇÃO META:</b
        >
        <div
          class="row"
          v-html="historico.new_values.profissionalizacao_meta"
        ></div>
        <b v-if="historico.new_values.profissionalizacaol_situacao_atual"
          >PROFISSIONALIZAÇÃO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.profissionalizacao_situacao_atual"
        ></div>

        <b v-if="historico.new_values.relacao_meta">RELAÇÃO META:</b>
        <div class="row" v-html="historico.new_values.relacao_meta"></div>
        <b v-if="historico.new_values.relacao_situacao_atual"
          >RELAÇÃO SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.relacao_situacao_atual"
        ></div>

        <b v-if="historico.new_values.saude_meta">SAUDÊ META:</b>
        <div class="row" v-html="historico.new_values.saude_meta"></div>
        <b v-if="historico.new_values.saude_situacao_atual"
          >SAUDÊ SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.saude_situacao_atual"
        ></div>

        <b v-if="historico.new_values.vulnerabildiade_meta"
          >VULNERABILIDADE META:</b
        >
        <div
          class="row"
          v-html="historico.new_values.vulnerabildiade_meta"
        ></div>
        <b v-if="historico.new_values.vulnerabildiade_situacao_atual"
          >VULNERABILIDADE SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.vulnerabildiade_situacao_atual"
        ></div>

        <b v-if="historico.new_values.autonomia_meta">AUTONOMIA META:</b>
        <div class="row" v-html="historico.new_values.autonomia_meta"></div>
        <b v-if="historico.new_values.autonomiae_situacao_atual"
          >AUTONOMIA SITUAÇÃO ATUAL:</b
        >
        <div
          class="row"
          v-html="historico.new_values.autonomia_situacao_atual"
        ></div>

        <div
          class="row"
          v-html="makeHTML(historico.new_values.horario, 'HORÁRIO')"
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.salario, 'SALÁRIO')"
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.protocolo, 'PROTOCOLO')"
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.cadastrado, 'CADASTRADO')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.responsavel,
              'TÉCNICO RESPONSÁVEL',
              'name'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.unidade,
              'UNIDADE DO RESPONSÁVEL',
              'nome'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.outros_tecnicos,
              'OUTRO(S) TÉCNICO(S)',
              null,
              true
            )
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.tipo, 'TIPO DE ATENDIMENTO')"
        ></div>
        <div
          class="row"
          v-if="historico.new_values.tipo == 'ABORDAGEM SOCIAL'"
          v-html="
            makeHTML(
              historico.new_values.situacao_abordagem_social_nomes,
              'SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.outra_situacao_abordagem_social,
              'OUTRAS SITUAÇÕES IDENTIFICADAS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.status_nome, 'STATUS')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.privado,
              'SIGILO',
              null,
              false,
              true,
              ['1', 'Sim', 'Não']
            )
          "
        ></div>

        <div class="row">
          <div class="col-12" v-if="historico.new_values.familia">
            <b>USUÁRIO(S) ATENDIDO(S):</b>
            <b
              class="mr-2 badge badge-default"
              v-for="(pessoa, index) in historico.new_values.pessoas"
              :key="pessoa.id"
            >
              {{ pessoa.nome_completo }}
            </b>
            <small
              class="badge badge-danger my-2"
              v-if="
                historico.new_values.familia.rf_situacao_rua != null &&
                historico.new_values.familia.rf_situacao_rua.status == 1
              "
              >RF registrado em Situação de Rua no Sistema</small
            >
          </div>
        </div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.tipo_servico_id,
                servicos
              ),
              'SERVIÇO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.local, 'LOCAL')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.assessoramento_juridico,
                $root.arrays.assessoramento_juridico
              ),
              'ASSESSORAMENTO JURÍDICO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.reincidencia,
                $root.arrays.reincidencia
              ),
              'REINCIDÊNCIA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.ato_inflacional,
                $root.arrays.ato_inflacional
              ),
              'ATO INFRACIONAL'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.registro_carteira,
                $root.arrays.pergunta
              ),
              'REGISTRO EM CARTEIRA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.estudo_acompanhamento,
                $root.arrays.pergunta
              ),
              'EM ESTUDO E ACOMPANHAMENTO DA SITUAÇÃO FAMILIAR'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.crianca_orfao,
                $root.arrays.pergunta
              ),
              'CRIANÇA/ADOLESCENTE ÓRFÃO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.intereressados_acolher,
                $root.arrays.pergunta
              ),
              'ENTRE OS PARENTES IDENTIFICADOS, HÁ INTERESSADOS EM ACOLHER A CRIANÇA/ADOLESCENTE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.condicao_higiene,
                $root.arrays.pergunta
              ),
              'A CRIANÇA/ADOLESCENTE ENCONTRAVA-SE EM BOAS CONDIÇÕES DE HIGIENE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.chegou_agitada,
                $root.arrays.pergunta
              ),
              'A CRIANÇA/ADOLESCENTE ESTAVA AGITADA AO CHEGAR NA UNIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.chegou_chorando,
                $root.arrays.pergunta
              ),
              'A CRIANÇA/ADOLESCENTE ESTAVA CHORANDO AO CHEGAR NA UNIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.dificuldade_dormir,
                $root.arrays.pergunta
              ),
              'A CRIANÇA/ADOLESCENTE APRESENTOU DIFICULDADE PARA DORMIR'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.enurese_noturna,
                $root.arrays.pergunta
              ),
              'A CRIANÇA/ADOLESCENTE APRESENTOU ENURESE NOTURNA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.vestigio_psicoativo,
                $root.arrays.pergunta
              ),
              'A CRIANÇA ADOLESCENTE APRESENTAVA VESTÍGIOS DO USO DE ALGUMA SUBSTÂNCIA PSICOATIVA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.violencia_fisica,
                $root.arrays.pergunta
              ),
              'A CRIANÇA ADOLESCENTE APRESENTAVA ALGUM SINAL DE VIOLÊNCIA FÍSICA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.violacia_sexual,
                $root.arrays.pergunta
              ),
              'A CRIANÇA ADOLESCENTE APRESENTAVA ALGUM SINAL DE VIOLÊNCIA SEXUAL'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.vivencia_negligencia,
                $root.arrays.pergunta
              ),
              'A CRIANÇA ADOLESCENTE APRESENTAVA ASPECTOS QUE INDICAM A VIVÊNCIA DE NEGLIGÊNCIA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.aspectos_pessoais,
                $root.arrays.acolhimento_aspectos_pessoais
              ),
              'ASPECTOS PESSOAIS OBSERVADOS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.unidade_acolhimento_proxima,
                $root.arrays.pergunta
              ),
              'A UNIDADE DE ACOLHIMENTO LOCALIZA-SE PRÓXIMO À RESIDÊNCIA DOS PAIS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.residia_familia_origem,
                $root.arrays.pergunta
              ),
              'NO MOMENTO DO ACOLHIMENTO RESIDIA COM A FAMÍLIA DE ORIGEM'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.preparacao_reintegracao_natural,
                $root.arrays.pergunta
              ),
              'PREPARAÇÃO PARA REINTEGRAÇÃO FAMILIAR (FAMÍLIA NATURAL)'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.preparacao_reintegracao_extensa,
                $root.arrays.pergunta
              ),
              'PREPARAÇÃO PARA REINTEGRAÇÃO FAMILIAR (FAMÍLIA EXTENSA)'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.poder_fam_destituido,
                $root.arrays.pergunta
              ),
              'PODER FAMILIAR DESTITUÍDO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.processo_guarda,
                $root.arrays.pergunta
              ),
              'EM PROCESSO DE GUARDA/TUTELA/ADOÇÃO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.sem_informacao,
                $root.arrays.pergunta
              ),
              'SEM INFORMAÇÃO DA FAMÍLIA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.experiencia_anterior,
                $root.arrays.pergunta
              ),
              'EXPERIÊNCIAS ANTERIORES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.participou_cursos,
                $root.arrays.pergunta
              ),
              'JÁ PARTICIPOU DE CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.pronuncia_correta,
                $root.arrays.pergunta
              ),
              'PRONUNCIA CORRETAMENTE AS PALAVRAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.troca_letra,
                $root.arrays.pergunta
              ),
              'TROCA LETRAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.omite_letras,
                $root.arrays.pergunta
              ),
              'OMITE LETRAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.compreende_perguntas,
                $root.arrays.pergunta
              ),
              'COMPREENDE PERGUNTAS QUE LHE SÃO FEITAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.gagueira,
                $root.arrays.pergunta
              ),
              'APRESENTA GAGUEIRAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.apetite,
                $root.arrays.pergunta
              ),
              'TEM BOM APETITE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.alergia_alimento,
                $root.arrays.pergunta
              ),
              'TEM ALERGIA A ALGUM ALIMENTO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.recusa_alimentar,
                $root.arrays.pergunta
              ),
              'RECUSA ALIMENTAÇÃO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.ajuda_alimentar,
                $root.arrays.pergunta
              ),
              'NECESSITA DE AJUDA PARA SE ALIMENTAR'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.cartao_vacina,
                $root.arrays.pergunta
              ),
              'POSSUI CARTÃO DE VACINA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.cartao_atualizado,
                $root.arrays.pergunta
              ),
              'O CARTÃO ESTÁ ATUALIZADO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.estabanada,
                $root.arrays.pergunta
              ),
              'É DESASTRADA/DESATENCIOSA (ESBARRA NOS MÓVEIS, DERRUBA ÁGUA OU COMIDA NA MESA)'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.problema_ortopedico,
                $root.arrays.pergunta
              ),
              'APRESENTA ALGUM PROBLEMA ORTOPÉDICO (PÉ CHATO, TORTO ETC.)'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.aproxima_objetos,
                $root.arrays.pergunta
              ),
              'APROXIMA MUITO OS OBJETOS PARA VÊ-LOS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.aperta_olhos,
                $root.arrays.pergunta
              ),
              'APERTA OS OLHOS PARA OLHAR À DISTÂNCIA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.inflamacao_ouvidos,
                $root.arrays.pergunta
              ),
              'COSTUMA TER INFLAMAÇÕES NOS OUVIDOS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.reacao_ruidos,
                $root.arrays.pergunta
              ),
              'APRESENTA REAÇÕES DIFERENTES A RUÍDOS DIFERENTES'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.reacao_cheiros,
                $root.arrays.pergunta
              ),
              'APRESENTA ALGUMA REAÇÃO ESPECIAL A DIFERENTES TIPOS DE CHEIRO E GOSTO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.tomou_vacinas,
                $root.arrays.pergunta
              ),
              'TOMOU AS VACINAS NECESSÁRIAS CONFORME A IDADE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.doencas_infantis,
                $root.arrays.pergunta
              ),
              'QUE DOENÇAS INFANTIS JÁ TEVE'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.doencas_infantis == 5"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.doencas_outras,
                $root.arrays.pergunta
              ),
              'QUAIS OUTRAS DOENÇAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.alergia,
                $root.arrays.pergunta
              ),
              'TEM ALERGIAS'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.alergia == 1"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.alergia_a_que,
                $root.arrays.pergunta
              ),
              'A QUE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.sofreu_acidente,
                $root.arrays.pergunta
              ),
              'JÁ SOFREU ALGUM ACIDENTE OU QUEDA'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.sofreu_acidente == 1"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.como_reagiu_acidente,
                $root.arrays.pergunta
              ),
              'COMO REAGIU'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.encaminhar_atendimento_medico == 1"
          v-html="
            makeHTML(historico.new_values.atendimento_medico_quais, 'QUAIS')
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.sexualidade_compativel_idade == 1"
          v-html="
            makeHTML(
              historico.new_values.sexualidade_compativel_porque,
              'POR QUE'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.apresenta_tique == 1"
          v-html="makeHTML(historico.new_values.tique_descricao, 'DESCREVA')"
        ></div>

        <div
          class="row"
          v-if="historico.new_values.irrita_facil == 1"
          v-html="
            makeHTML(
              historico.new_values.reage_frustacao,
              'COMO REAGE QUANDO FRUSTRADO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.expressa_emocoes,
              'COMO EXPRESSA SUAS EMOÇÕES? (É ESPONTÂNEO NOS AFETOS, TOLHIDO, FOGE DOS CONTATOS)'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.reage_raiva,
              'COMO REAGE QUANDO TEM RAIVA? (ISOLA - SE, TORNA-SE AGRESSIVO)'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.medo == 1"
          v-html="makeHTML(historico.new_values.medo_de_que, 'QUAIS')"
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.cuidado_especial,
                $root.arrays.pergunta
              ),
              'PRECISA DE ALGUM CUIDADO ESPECIAL POR MOTIVO DE SAÚDE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.chora_frequente,
                $root.arrays.pergunta
              ),
              'CHORA FREQUENTEMENTE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.necessita_disciplina,
                $root.arrays.pergunta
              ),
              'ACEITA SER DISCIPLINADO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.respeita_autoridade,
                $root.arrays.pergunta
              ),
              'RESPEITA A FIGURA DA AUTORIDADE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.aproximacao_pai,
                $root.arrays.pergunta
              ),
              'TEM BOA APROXIMAÇÃO COM O PAI'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.aproximacao_mae,
                $root.arrays.pergunta
              ),
              'TEM BOA APROXIMAÇÃO COM A MÃE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.preferencia_genitores,
                $root.arrays.pergunta
              ),
              'MOSTRA PREFERÊNCIA POR UM DOS GENITORES'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.bem_entre_irmaos,
                $root.arrays.pergunta
              ),
              'SENTE-SE BEM ENTRE OS IRMÃOS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.relacao_boa_acolidos,
                $root.arrays.pergunta
              ),
              'RELACIONA-SE BEM COM OS OUTROS ACOLHIDOS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.relacao_boa_funcionarios,
                $root.arrays.pergunta
              ),
              'RELACIONA-SE BEM COM OS FUNCIONÁRIOS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.brinca,
                $root.arrays.pergunta
              ),
              'GOSTA DE BRINCAR'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.preferencia_genitores == 1"
          v-html="
            makeHTML(
              historico.new_values.preferencia_genitores_motivo,
              'POR QUAL MOTIVO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.chupeta,
                $root.arrays.pergunta
              ),
              'USA CHUPETA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.brinca_com_pessoas,
                $root.arrays.pergunta
              ),
              'BRINCA COM PESSOAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.interrupcao_estudos,
                $root.arrays.pergunta
              ),
              'HOUVE INTERRUPÇÃO NOS ESTUDOS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.dificuldade_aprendizagem,
                $root.arrays.pergunta
              ),
              'APRESENTA DIFICULDADE DE APRENDIZAGEM'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.frequenta_programa_social,
                $root.arrays.pergunta
              ),
              'FREQUENTA PROGRAMAS SOCIAIS – CONTRA TURNO ESCOLAR'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.frequenta_programa_social == 1"
          v-html="
            makeHTML(
              historico.new_values.unidade_programa_social,
              'QUAL A UNIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.metodo_aprendizagem,
              'QUAL MÉTODO DE ENSINO TERIA MAIOR FACILIDADE DE APRENDIZAGEM EM RAZÃO DO SEU PERFIL COMPORTAMENTAL'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.consideracao_escolar,
              'CONSIDERAÇÕES SOBRE A VIDA ESCOLAR (FREQUÊNCIA,COMPORTAMENTO, APRENDIZAGEM)'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.local, 'QUAL O LOCAL DO TRABALHO')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.numero_processo, 'NÚMERO DO PROCESSO')
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.numero_guia_acolhimento,
              'NÚMERO DA GUIA DE ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.numero_guia_desligamento,
              'NÚMERO DA GUIA DE DESLIGAMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.nome_tribunal, 'NOME DO TRIBUNAL')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.nome_comarca, 'NOME DA COMARCA')
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.nome_responsavel_caso,
              'NOME DA VARA ESPECIALIZADA RESPONSÁVEL PELO CASO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.endereco_vara,
              'ENDEREÇO DA VARA ESPECIALIZADA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.pessoa_referencia_vara,
              'PESSOA DE REFERÊNCIA NA VARA ESPECIALIZADA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="makeHTML(historico.new_values.horario, 'QUAL O HORÁRIO')"
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.salario, 'SALÁRIO')"
        ></div>
        <div
          class="row"
          v-if="historico.new_values.participou_cursos == 1"
          v-html="
            makeHTML(
              historico.new_values.qual_curso,
              'QUAIS CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.gostaria_participar == 1"
          v-html="
            makeHTML(
              historico.new_values.quais_cursos_gostaria_participar,
              'QUAIS CURSOS GOSTARIA DE PARTICIPAR'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.solicitante == 4"
          v-html="makeHTML(historico.new_values.solicitante_outros, 'OUTRO')"
        ></div>

        <div
          class="row"
          v-if="historico.new_values.possui_irmao_unidade == 1"
          v-html="makeHTML(historico.new_values.quant_irmao_unidade, 'QUANTOS')"
        ></div>

        <div
          class="row"
          v-if="
            historico.new_values.motivo == 19 ||
            historico.new_values.motivo == 18
          "
          v-html="
            makeHTML(
              historico.new_values.motivo_outros,
              'ESPECIFIQUE OUTROS OU NEGLIGÊNCIA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.termo_acolhimento,
              'TERMO DE ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.data_acolhimento,
              'DATA DO ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.hora_acolhimento,
              'HORA DO ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.medida_nome_unidade"
          v-html="
            makeHTML(
              historico.new_values.medida_nome_unidade,
              'NOME DA UNIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.medida_endereco"
          v-html="
            makeHTML(
              historico.new_values.medida_endereco,
              'ENDEREÇO DA UNIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.medida_data_entrada"
          v-html="
            makeHTML(
              historico.new_values.medida_data_entrada,
              'DATA DE ENTRADA'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.medida_data_saida"
          v-html="
            makeHTML(historico.new_values.medida_data_saida, 'DATA DE SAÍDA')
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.medida_motivo"
          v-html="
            makeHTML(
              historico.new_values.medida_motivo,
              'MOTIVO DO ACOLHIMENTO'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.medida_motivo_desligamento"
          v-html="
            makeHTML(
              historico.new_values.medida_motivo_desligamento,
              'MOTIVO DO DESLIGAMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.nome_parentesco_guarda"
          v-html="
            makeHTML(
              historico.new_values.nome_parentesco_guarda,
              'NOME E PARENTESCO DA PESSOA QUE ASSUMIU A GUARDA APÓS O DESLIGAMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-if="historico.new_values.autores_violencia_violacao_outro"
          v-html="
            makeHTML(
              historico.new_values.autores_violencia_violacao_outro,
              'QUAL'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.motivo,
                $root.arrays.acolhimento_motivo
              ),
              'MOTIVO(S) DO ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.autores_violencia_violacao,
                $root.arrays.autores_violencia_violacao
              ),
              'CONSIDERANDO OS MOTIVOS DO ACOLHIMENTO, INFORME QUEM É / OU SÃO O(S) SUPOSTO(S) AUTOR(ES) DA VIOLÊNCIA/VIOLAÇÃO DE DIREITOS OU RESPONSÁVEL(IS) QUE ESTÁ(ÃO) IMPOSSIBILITADO(S) DE PRESTAR OS CUIDADOS E PROTEÇÃO NECESSÁRIOS À CRIANÇA/ADOLESCENTE'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.impedimento_judicial == 1"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.autores_violencia_violacao_outro,
                $root.arrays.pergunta
              ),
              'SE SIM, INDIQUE AS PESSOAS IMPEDIDAS (APERTE ENTER, PARA INSERIR UMA OU MAIS PESSOAS)'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.medidas_antes_acolhimento == 1"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.pessoas_impedidas,
                $root.arrays.pergunta
              ),
              'REGISTRO EM CARTEIRA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.medidas_antes_aplicadas,
                $root.arrays.medidas_antes_aplicadas
              ),
              'QUAL'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.medidas_antes_acolhimento,
                $root.arrays.pergunta
              ),
              'FORAM APLICADAS OUTRAS MEDIDAS DE PROTEÇÃO ANTES DO ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.impedimento_judicial,
                $root.arrays.pergunta
              ),
              'HÁ IMPEDIMENTO JUDICIAL QUE IMPEÇA O CONTATO DOS PAIS/RESPONSÁVEIS COM A CRIANÇA/ADOLESCENTE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.crianca_cadastro_desaparecida,
                $root.arrays.pergunta
              ),
              'CRIANÇA/ ADOLESCENTE INCLUÍDO NO CADASTRO NACIONAL DA CRIANÇA OU ADOLESCENTE DESAPARECIDO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.crianca_cadastro_adocao,
                $root.arrays.pergunta
              ),
              'CRIANÇA/ADOLESCENTE ESTÁ INCLUÍDO NO CADASTRO NACIONAL DE ADOÇÃO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.cumprimento_medidas,
                $root.arrays.pergunta
              ),
              'ADOLESCENTE CUMPRINDO MEDIDA SOCIOEDUCATIVA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.acolhido_anteriomente,
                $root.arrays.pergunta
              ),
              'CRIANÇA/ADOLESCENTE FOI ACOLHIDA ANTERIORMENTE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.medida_protetiva_aplicada,
                $root.arrays.medida_protetiva_aplicada
              ),
              'MEDIDA PROTETIVA DE ACOLHIMENTO INSTITUCIONAL APLICADA'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.deseja_alguma_profissao,
                $root.arrays.pergunta
              ),
              'DESEJA SEGUIR ALGUMA PROFISSÃO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.possui_irmao_unidade,
                $root.arrays.pergunta
              ),
              'POSSUI IRMÃO NA UNIDADE DE ACOLHIMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.solicitante,
                $root.arrays.acolhimento_solicitantes
              ),
              'SOLICITAÇÃO DE VAGA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.qual_profissao_interesse,
                $root.ocupacoes
              ),
              'QUAL DAS PROFISSÕES, DE ACORDO COM A CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES, TEM INTERESSE DE SEGUIR'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.observacoes,
              'OBSERVAÇÃO SOBRE AS COMPETÊNCIAS PROFISSIONAIS IDENTIFICADAS/APTIDÕES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.experiencia_anterior,
                $root.arrays.pergunta
              ),
              'EXPERIÊNCIAS ANTERIORES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.gostaria_participar,
                $root.arrays.pergunta
              ),
              'GOSTARIA DE PARTICIPAR DE CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.participou_cursos,
                $root.arrays.pergunta
              ),
              'JÁ PARTICIPOU DE CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.irrita_facil,
                $root.arrays.pergunta
              ),
              'IRRITA-SE FACILMENTE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.trabalhando,
                $root.arrays.pergunta
              ),
              'ESTÁ TRABALHANDO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.medo,
                $root.arrays.pergunta
              ),
              'DEMONSTROU MEDO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.roi_unha,
                $root.arrays.pergunta
              ),
              'RÓI UNHAS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.chupa_dedo,
                $root.arrays.pergunta
              ),
              'CHUPA DEDO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.apresenta_tique,
                $root.arrays.pergunta
              ),
              'APRESENTA ALGUM TIQUE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.sexualidade_compativel_idade,
                $root.arrays.pergunta
              ),
              'SUA SEXUALIDADE É COMPATÍVEL COM A IDADE'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.ind_acompanhamento_psicologico,
                $root.arrays.pergunta
              ),
              'HÁ INDICAÇÃO PARA ACOMPANHAMENTO PSICOLÓGICO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.ja_acompanhamento_psicologico,
                $root.arrays.pergunta
              ),
              'JÁ PASSOU POR ACOMPANHAMENTO PSICOLÓGICO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.encaminhar_atendimento_medico,
                $root.arrays.pergunta
              ),
              'É NECESSÁRIO ENCAMINHAMENTO PARA ATENDIMENTO MÉDICO ESPECIALIZADO'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.uso_prolongado_medicamento,
                $root.arrays.pergunta
              ),
              'FAZ USO CONSTANTE OU PROLONGADO DE MEDICAMENTOS'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.uso_prolongado_medicamento == 1"
          v-html="
            makeHTML(
              historico.new_values.uso_medicamento_quais,
              'QUAIS MEDICAMENTOS'
            )
          "
        ></div>

        <div
          class="row"
          v-if="historico.new_values.uso_prolongado_medicamento == 1"
          v-html="
            makeHTML(
              historico.new_values.uso_medicamento_periodo,
              'QUAL PERÍODO MEDICAMENTOS'
            )
          "
        ></div>

        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.metas_pia,
                $root.arrays.metas_pia
              ),
              'AS METAS E OBJETIVOS ESTABELECIDAS NO PIA FORAM ALCANÇADOS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.cumpriu_condicionalidade,
                $root.arrays.cumpriu_condicionalidade
              ),
              'O ADOLESCENTE CUMPRIU COM AS CONDICIONALIDADES ESTABELECIDAS NO TERMO DE COMPROMISSO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.disponibilidade_adolescente,
                $root.arrays.medidas_avaliacao
              ),
              'SOBRE A DISPONIBILIDADE DO ADOLESCENTE PARA REALIZAR AS ATIVIDADES PROPOSTAS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.pontualidade,
                $root.arrays.medidas_avaliacao
              ),
              'PONTUALIDADE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.sociabilidade,
                $root.arrays.medidas_avaliacao
              ),
              'SOCIABILIDADE COM A EQUIPE E NO LOCAL DE PRESTAÇÃO DA MEDIDA'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.participacao_cumprimento,
                $root.arrays.medidas_avaliacao
              ),
              'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.participacao_cumprimento,
                $root.arrays.medidas_avaliacao
              ),
              'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.participacao_planejamento,
                $root.arrays.medidas_avaliacao
              ),
              'PARTICIPAÇÃO NO PLANEJAMENTO DO SEU CRONOGRAMA DE ATIVIDADES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.documentos_recebidos,
                $root.arrays.documentos_recebidos
              ),
              'DOCUMENTOS RECEBIDOS REFERENTE A MSE EM EXECUÇÃO E EXECUÇÕES ANTERIORES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.trabalhando,
                $root.arrays.pergunta
              ),
              'ESTÁ TRABALHANDO?'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.gostaria_participar,
                $root.arrays.pergunta
              ),
              'GOSTARIA DE PARTICIPAR DE CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              verificarValueArray(
                historico.new_values.deseja_alguma_profissao,
                $root.arrays.pergunta
              ),
              'DESEJA SEGUIR ALGUMA PROFISSÃO?'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.quais_cursos_gostaria_participar,
              'QUAIS CURSOS GOSTARIA DE PARTICIPAR'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.qual_curso,
              'QUAIS CURSOS PROFISSIONALIZANTES'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.planos_futuro, 'PLANOS FUTUROS')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.recebe_influencia_negativa,
              'O ADOLESCENTE RECEBE ALGUM TIPO DE INFLUÊNCIA NEGATIVA EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.recebe_apoio,
              'O ADOLESCENTE RECEBE ALGUM TIPO DE  APOIO OU ACOLHIMENTO EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.familia_corresponde,
              'A FAMILIA CORRESPONDE A ESTE INTERESSE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.familia_corresponde,
              'A FAMILIA CORRESPONDE A ESTE INTERESSE'
            )
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.observacoes, 'OBSERVAÇÃO')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.outros_documentos,
              'OUTROS DOCUMENTOS'
            )
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.numero, 'NÚMERO')"
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.autos, 'AUTOS Nº')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.outra_unidade_id, 'OUTRA UNIDADE')
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.outra_unidade, 'OUTRA UNIDADE')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.data_prevista_formatado,
              'DATA DO AGENDAMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.hora_prevista_formatado,
              'HORA DO AGENDAMENTO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.descricao_sumaria, 'OBSERVAÇÃO')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.processo_data_final,
              'DATA FINAL PROCESSO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.processo_data_inicial,
              'DATA INICIAL PROCESSO'
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.acomp_data_final,
              'DATA FINAL ACOMPANHAMENTO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.acomp_data_inicial,
              'DATA INICIAL ACOMPANHAMENTO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.documental_prazo,
              'SITUAÇÃO DOCUMENTAL PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.arte_prazo,
              'ARTE, CULTURA, ESPORTE E LAZER PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.aspecto_prazo,
              'ASPECTOS SOCIOFAMILIARES PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.processual_prazo, 'PROCESSUAL PRAZO ')
          "
        ></div>
        <div
          class="row"
          v-html="makeHTML(historico.new_values.saude_prazo, 'SAÚDE PRAZO ')"
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.educacao_prazo, 'EDUCAÇÃO PRAZO ')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.profissionalizacao_prazo,
              'PROFISSIONALIZAÇÃO PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.aspecto_prazo,
              'ASPECTOS SOCIOFAMILIARES PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.condicao_prazo,
              'CONDIÇÕES SOCIOECONÔMICAS PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.vulnerabildiade_prazo,
              'VULNERABILIDADE SOCIOFAMILIARES PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.desligamento_prazo,
              'PREPARAÇÃO PARA DESLIGAMENTO PRAZO '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(historico.new_values.data_avaliacao, 'DATA AVALIAÇÃO ')
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.orientador_social_responsavel_nome,
              'ORIENTADOR SOCIAL RESPONSÁVEl '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.acomp_creas_unidade_nome,
              'LOCAL CUMPRIMENTO DA MEDIDA '
            )
          "
        ></div>
        <div
          class="row"
          v-html="
            makeHTML(
              historico.new_values.acomp_creas_unidade_nome,
              'LOCAL CUMPRIMENTO DA MEDIDA '
            )
          "
        ></div>

        <div class="row">
          <div class="col-12 py-1" v-if="historico.new_values.vulnerabilidades">
            <b>VULNERABILIDADE(S):</b>
            <b
              class="mr-2 badge badge-default"
              v-for="(vulnerabilidade, index) in historico.new_values
                .vulnerabilidades"
              :key="vulnerabilidade.id"
            >
              {{ verificarValueArray(vulnerabilidade, vulnerabilidades_tipos) }}
            </b>
          </div>
          <div
            class="col-12 py-1"
            v-if="historico.new_values.aspectos_pessoais_outros"
          >
            <b> OUTROS ASPECTOS PESSOAIS:</b>
            <b
              class="mr-2 badge badge-default"
              v-for="(aspectos, index) in JSON.parse(
                historico.new_values.aspectos_pessoais_outros
              )"
              :key="aspectos"
            >
              {{ aspectos }}
            </b>
          </div>
          <div
            class="col-12 py-1"
            v-if="
              historico.new_values.denuncias &&
              historico.new_values.denuncias.length > 0
            "
          >
            <b>DENÚNCIAS:</b>
            <b
              class="mr-2 badge badge-default"
              v-for="(denuncia, index) in historico.new_values.denuncias"
              :key="index"
            >
              <router-link
                v-if="denuncia"
                class="btn btn-sm btn-light py-0 px-1 my-1"
                :to="`/dashboard/denuncias/edit/${denuncia.id}`"
              >
                {{ denuncia.protocolo }}
              </router-link>
            </b>
          </div>
        </div>
      </div>
    </div>

    <h2 v-if="historicos.length <= 0" class="text-warning">
      <span class="mdi mdi-clipboard-search-outline"></span> Por enquanto não
      temos nenhuma atualização.
    </h2>
  </div>
</template>
<script>
export default {
  props: ["id", "vulnerabilidades"],
  data() {
    return {
      loading: true,
      historicos: {},
      servicos: [],
      unidades: [],
      vulnerabilidades_tipos: [],
    };
  },
  watch: {
    vulnerabilidades() {
      this.vulnerabilidades_tipos = this.vulnerabilidades;
    },
  },
  mounted() {
    this.vulnerabilidades_tipos = this.vulnerabilidades;
    this.getHistorico();
    // this.getServicos();
    // this.getUnidades();
  },
  methods: {
    getHistorico() {
      this.loading = true;
      axios
        .get("api/dashboard/acolhimento/historico/audit/" + this.id)
        .then((response) => {
          this.historicos = response.data.historicos;
          this.servicos = response.data.servicos;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          swal.fire({
            title: "Ops!",
            html: `Os dados de auditoria não foram carregado corretamente<br>${error}`,
            icon: "error",
          });
        });
    },
    restaurar() {
      console.log("teste");
    },
    // getServicos() {
    //  axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
    //   this.servicos = response.data;
    //  });
    // },
    // getUnidades() {
    //  axios
    //   .get(`api/dashboard/unidades/get/externas/PLANTAO`)
    //   .then((response) => {
    //    this.unidades = response.data;
    //   });
    // },
    makeHTML(
      value,
      label,
      index = null,
      loop = false,
      select = false,
      options = null
    ) {
      if (value != null && value != "") {
        if (loop) {
          let itens = "";
          value.forEach((item) => {
            itens += `<b class="mr-2 badge badge-default">${item}</b>`;
          });
          return `<div class="col-12 py-1"><b>${label}:</b> ${itens}</div>`;
        } else if (select) {
          return `<div class="col-12 py-1"><b>${label}:</b> ${
            value == options[0] ? options[1] : options[2]
          }</div>`;
        } else {
          value = typeof value === "object" ? value[index] : value;
          return `<div class="col-12 py-1"><b>${label}:</b> ${value}</div>`;
        }
      }
    },
    verificarValueArray(value, array) {
      if (value != null && value != "") {
        const result = array.find((item) => item.id == value);
        return result ? result.value : "";
      }
    },
  },
};
</script>
